(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  var thumbs = document.querySelectorAll('.gallery-thumb');
  var mainImg = document.querySelector('.product-gallery__img');

  if (thumbs.length && mainImg) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('gallery-thumb--active'); });
        this.classList.add('gallery-thumb--active');
        mainImg.src = this.dataset.imageUrl;
        mainImg.alt = this.dataset.imageAlt;
      });
    });
  }

  var toggle = document.querySelector('.description-toggle');
  var desc = document.getElementById('product-description');
  if (toggle && desc) {
    toggle.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      desc.hidden = expanded;
    });
  }
})();

(function () {
  // Quantity ceiling. The inline stepUp()/stepDown() handlers this replaces honoured a
  // `max` attribute that was never rendered, so the counter climbed past available stock
  // and the customer only found out when Shopify silently clamped the cart.
  var wrap = document.querySelector('.product-quantity[data-variant-max]');
  if (!wrap) return;

  var input = wrap.querySelector('.quantity-field');
  var up    = wrap.querySelector('[data-qty="up"]');
  var down  = wrap.querySelector('[data-qty="down"]');
  var note  = wrap.querySelector('.quantity-note');
  var form  = document.getElementById('product-form');
  if (!input || !up || !down) return;

  var maxMap = {};
  try { maxMap = JSON.parse(wrap.getAttribute('data-variant-max') || '{}'); } catch (e) {}

  // null means genuinely unlimited (untracked stock, or overselling allowed).
  function ceiling() {
    var idEl = form && form.querySelector('[name="id"]');
    var max = idEl ? maxMap[String(idEl.value)] : undefined;
    return (max === undefined || max < 0) ? null : max;
  }

  function sync() {
    var max = ceiling();
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    if (max !== null && val > max) val = max;
    input.value = val;

    if (max === null) input.removeAttribute('max');
    else input.setAttribute('max', String(max));

    var atMax = max !== null && val >= max;
    up.disabled = atMax;
    down.disabled = val <= 1;

    if (note) {
      if (atMax) {
        note.textContent = max === 1 ? 'Only 1 left' : 'Only ' + max + ' available';
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }
  }

  up.addEventListener('click', function () {
    var max = ceiling();
    var val = parseInt(input.value, 10) || 1;
    if (max === null || val < max) input.value = val + 1;
    sync();
  });

  down.addEventListener('click', function () {
    var val = parseInt(input.value, 10) || 1;
    if (val > 1) input.value = val - 1;
    sync();
  });

  input.addEventListener('input', sync);
  input.addEventListener('blur', sync);

  // Re-evaluate if a variant selector changes the posted variant id.
  var options = document.querySelector('.product-options');
  if (options) options.addEventListener('change', function () { setTimeout(sync, 0); });

  sync();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  var btn = document.getElementById('sort-btn');
  var menu = document.getElementById('sort-menu');
  if (btn && menu) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = !menu.hidden;
      menu.hidden = open;
      btn.setAttribute('aria-expanded', String(!open));
    });
    document.addEventListener('click', function () {
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        menu.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }
    });
  }

  var searchToggle = document.getElementById('predictive-search-toggle');
  var searchPanel = document.getElementById('predictive-search-panel');
  var searchClose = document.getElementById('predictive-search-close');
  var searchInput = document.getElementById('predictive-search-input');
  var searchResults = document.getElementById('predictive-search-results');
  var searchStatus = document.getElementById('predictive-search-status');
  var searchAll = document.getElementById('predictive-search-all');
  var searchTimer;
  var searchRequest;
  var activeResult = -1;

  function closeSearch(restoreFocus) {
    if (!searchPanel || searchPanel.hidden) return;
    searchPanel.hidden = true;
    searchToggle.setAttribute('aria-expanded', 'false');
    if (restoreFocus) searchToggle.focus();
  }

  function openSearch() {
    searchPanel.hidden = false;
    searchToggle.setAttribute('aria-expanded', 'true');
    if (menu && btn) {
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }
    window.setTimeout(function () { searchInput.focus(); }, 0);
  }

  function resultLinks() {
    return Array.prototype.slice.call(searchResults.querySelectorAll('.predictive-result'));
  }

  function setActiveResult(index) {
    var links = resultLinks();
    links.forEach(function (link) { link.classList.remove('is-keyboard-active'); });
    if (!links.length) {
      activeResult = -1;
      return;
    }
    activeResult = (index + links.length) % links.length;
    links[activeResult].classList.add('is-keyboard-active');
    links[activeResult].focus();
  }

  function productImage(product) {
    if (!product.image) return '';
    return typeof product.image === 'string' ? product.image : product.image.url;
  }

  function productPrice(product) {
    var value = parseFloat(product.price);
    if (Number.isNaN(value)) return product.price || '';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
      style: 'currency',
      currency: 'AUD'
    }).format(value);
  }

  function renderProducts(products, query) {
    searchResults.replaceChildren();
    activeResult = -1;
    searchAll.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
    searchAll.hidden = false;

    if (!products.length) {
      searchStatus.textContent = 'No products found for “' + query + '”.';
      return;
    }

    searchStatus.textContent = products.length + (products.length === 1 ? ' product found.' : ' products found.');
    products.forEach(function (product) {
      var link = document.createElement('a');
      var imageUrl = productImage(product);
      var copy = document.createElement('span');
      var title = document.createElement('span');
      var price = document.createElement('span');

      link.className = 'predictive-result';
      link.href = product.url;

      if (imageUrl) {
        var image = document.createElement('img');
        image.className = 'predictive-result__image';
        image.src = imageUrl;
        image.alt = '';
        image.loading = 'lazy';
        link.appendChild(image);
      } else {
        var placeholder = document.createElement('span');
        placeholder.className = 'predictive-result__image';
        placeholder.setAttribute('aria-hidden', 'true');
        link.appendChild(placeholder);
      }

      title.className = 'predictive-result__title';
      title.textContent = product.title;
      price.className = 'predictive-result__price';
      price.textContent = productPrice(product);
      copy.appendChild(title);
      copy.appendChild(price);
      link.appendChild(copy);
      searchResults.appendChild(link);
    });
  }

  function runPredictiveSearch(query) {
    if (searchRequest) searchRequest.abort();
    searchRequest = new AbortController();
    searchStatus.textContent = 'Searching…';

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last', {
      signal: searchRequest.signal,
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Search request failed');
        return response.json();
      })
      .then(function (data) {
        var products = data.resources && data.resources.results ? data.resources.results.products || [] : [];
        renderProducts(products, query);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        searchResults.replaceChildren();
        searchStatus.textContent = 'Search is temporarily unavailable. Press Enter to view full results.';
        searchAll.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
        searchAll.hidden = false;
      });
  }

  if (searchToggle && searchPanel && searchClose && searchInput && searchResults && searchStatus && searchAll) {
    searchToggle.addEventListener('click', function (event) {
      event.stopPropagation();
      if (searchPanel.hidden) openSearch();
      else closeSearch(true);
    });

    searchClose.addEventListener('click', function () { closeSearch(true); });

    searchInput.addEventListener('input', function () {
      window.clearTimeout(searchTimer);
      var query = searchInput.value.trim();
      searchResults.replaceChildren();
      searchAll.hidden = true;
      activeResult = -1;

      if (query.length < 2) {
        if (searchRequest) searchRequest.abort();
        searchStatus.textContent = query.length ? 'Type one more character to search.' : 'Start typing to search The Reference.';
        return;
      }

      searchTimer = window.setTimeout(function () { runPredictiveSearch(query); }, 180);
    });

    searchPanel.addEventListener('click', function (event) { event.stopPropagation(); });
    document.addEventListener('click', function () { closeSearch(false); });

    document.addEventListener('keydown', function (event) {
      if (searchPanel.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeSearch(true);
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActiveResult(activeResult + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActiveResult(activeResult - 1);
      }
    });
  }

  // ── Tier Filter + Ranking Sort + Client-side Pagination ──────────────────
  // All 250 products are loaded by Liquid at once. JS handles show/hide,
  // sorting, and page-by-page display (32 per page). No URL tricks needed.
  (function () {
    var PAGE_SIZE    = 32;
    var filterBtn    = document.getElementById('filter-btn');
    var filterDrawer = document.getElementById('filter-drawer');
    var filterApply  = document.getElementById('filter-apply');
    var filterClear  = document.getElementById('filter-clear');
    var filterCount  = document.getElementById('filter-active-count');
    var metaCount    = document.getElementById('shop-meta-count');
    var metaFilter   = document.getElementById('shop-meta-filter');
    var metaLabel    = document.getElementById('shop-meta-filter-label');
    var noResults    = document.getElementById('grid-no-results');
    var sortLabel    = document.getElementById('sort-label');
    var paginationEl = document.getElementById('js-pagination');
    var chips        = document.querySelectorAll('.tier-chip');
    var activeTiers  = [];
    var currentPage  = 1;
    var allCards     = [];
    var filteredCards = [];

    function getChecked() {
      return Array.prototype.slice.call(document.querySelectorAll('.tier-chip__input:checked')).map(function (cb) { return cb.value; });
    }

    function syncChipStyles() {
      chips.forEach(function (chip) {
        var cb = chip.querySelector('.tier-chip__input');
        if (cb && cb.checked) chip.classList.add('tier-chip--active');
        else chip.classList.remove('tier-chip--active');
      });
    }

    function openDrawer() {
      if (!filterDrawer) return;
      filterDrawer.classList.add('is-open');
      if (filterBtn) filterBtn.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      if (!filterDrawer) return;
      filterDrawer.classList.remove('is-open');
      if (filterBtn) filterBtn.setAttribute('aria-expanded', 'false');
    }

    function renderPage(page) {
      var start = (page - 1) * PAGE_SIZE;
      var end   = start + PAGE_SIZE;
      filteredCards.forEach(function (card, i) {
        card.style.display = (i >= start && i < end) ? '' : 'none';
      });
      currentPage = page;
      buildPagination();
      if (window._fitTitles) window._fitTitles();
      // Scroll to top of product grid
      var grid = document.getElementById('product-grid');
      if (grid && page > 1) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function buildPagination() {
      if (!paginationEl) return;
      var totalPages = Math.ceil(filteredCards.length / PAGE_SIZE);
      paginationEl.innerHTML = '';
      if (totalPages <= 1) { paginationEl.style.display = 'none'; return; }

      paginationEl.style.display = 'flex';

      // Prev
      if (currentPage > 1) {
        var prev = document.createElement('span');
        prev.className = 'prev';
        var prevA = document.createElement('a');
        prevA.href = '#';
        prevA.textContent = '←';
        prevA.dataset.pg = currentPage - 1;
        prev.appendChild(prevA);
        paginationEl.appendChild(prev);
      }

      // Pages
      for (var p = 1; p <= totalPages; p++) {
        var span = document.createElement('span');
        span.className = 'page';
        if (p === currentPage) {
          var cur = document.createElement('span');
          cur.className = 'current';
          cur.textContent = p;
          span.appendChild(cur);
        } else {
          var a = document.createElement('a');
          a.href = '#';
          a.textContent = p;
          a.dataset.pg = p;
          span.appendChild(a);
        }
        paginationEl.appendChild(span);
      }

      // Next
      if (currentPage < totalPages) {
        var next = document.createElement('span');
        next.className = 'next';
        var nextA = document.createElement('a');
        nextA.href = '#';
        nextA.textContent = '→';
        nextA.dataset.pg = currentPage + 1;
        next.appendChild(nextA);
        paginationEl.appendChild(next);
      }

      paginationEl.addEventListener('click', function (e) {
        var target = e.target.closest('a[data-pg]');
        if (!target) return;
        e.preventDefault();
        renderPage(parseInt(target.dataset.pg, 10));
      });
    }

    function applyFilterAndPaginate() {
      allCards = Array.prototype.slice.call(document.querySelectorAll('#product-grid .product-card'));
      filteredCards = activeTiers.length === 0
        ? allCards.slice()
        : allCards.filter(function (card) { return activeTiers.indexOf(card.dataset.tier) !== -1; });

      // Hide all first, then show current page
      allCards.forEach(function (c) { c.style.display = 'none'; });
      currentPage = 1;
      renderPage(1);

      // Meta count
      if (metaCount) metaCount.textContent = filteredCards.length + ' product' + (filteredCards.length !== 1 ? 's' : '');

      // Filter tag
      if (activeTiers.length > 0 && metaFilter) {
        metaFilter.style.display = '';
        if (metaLabel) metaLabel.textContent = activeTiers.map(function (t) { return t.charAt(0).toUpperCase() + t.slice(1); }).join(' + ');
      } else if (metaFilter) {
        metaFilter.style.display = 'none';
        if (metaCount) {
          // Restore Shopify count when no filter
          var grid = document.getElementById('product-grid');
          if (grid) {
            var total = grid.querySelectorAll('.product-card').length;
            metaCount.textContent = total + ' product' + (total !== 1 ? 's' : '');
          }
        }
      }

      // No results
      if (noResults) noResults.style.display = filteredCards.length === 0 ? 'flex' : 'none';

      // Filters button badge
      if (filterCount) {
        if (activeTiers.length > 0) {
          filterCount.textContent = activeTiers.length;
          filterCount.hidden = false;
          if (filterBtn) filterBtn.classList.add('filter-filters-btn--active');
        } else {
          filterCount.hidden = true;
          if (filterBtn) filterBtn.classList.remove('filter-filters-btn--active');
        }
      }
    }

    function applySort(direction) {
      var grid = document.getElementById('product-grid');
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
      cards.sort(function (a, b) {
        var sa = parseInt(a.dataset.score || '0', 10);
        var sb = parseInt(b.dataset.score || '0', 10);
        return direction === 'desc' ? sb - sa : sa - sb;
      });
      cards.forEach(function (c) { grid.appendChild(c); });
      // Re-apply pagination after sort
      applyFilterAndPaginate();
    }

    // Chip visual sync
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () { setTimeout(syncChipStyles, 0); });
    });

    // Drawer toggle
    if (filterBtn) {
      filterBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (filterDrawer && filterDrawer.classList.contains('is-open')) closeDrawer();
        else openDrawer();
      });
    }

    // Apply filter
    if (filterApply) {
      filterApply.addEventListener('click', function () {
        activeTiers = getChecked();
        syncChipStyles();
        closeDrawer();
        applyFilterAndPaginate();
      });
    }

    // Clear filter
    if (filterClear) {
      filterClear.addEventListener('click', function () {
        activeTiers = [];
        document.querySelectorAll('.tier-chip__input').forEach(function (cb) { cb.checked = false; });
        syncChipStyles();
        closeDrawer();
        if (sortLabel) { sortLabel.textContent = 'Sort'; }
        document.querySelectorAll('.sort-ranking-btn').forEach(function (b) { b.classList.remove('sort-menu__link--active'); });
        applyFilterAndPaginate();
      });
    }

    // Ranking sort (client-side, works on all loaded products)
    document.querySelectorAll('.sort-ranking-btn').forEach(function (rankBtn) {
      rankBtn.addEventListener('click', function () {
        var dir = rankBtn.dataset.sort === 'score-desc' ? 'desc' : 'asc';
        applySort(dir);
        if (sortLabel) sortLabel.textContent = dir === 'desc' ? 'Ranking ↓' : 'Ranking ↑';
        document.querySelectorAll('.sort-ranking-btn').forEach(function (b) { b.classList.remove('sort-menu__link--active'); });
        rankBtn.classList.add('sort-menu__link--active');
        if (menu) { menu.hidden = true; }
        if (btn)  { btn.setAttribute('aria-expanded', 'false'); }
      });
    });

    // Auto-apply tier from URL param (for My Reference framework links: ?tier=gold)
    var tierParam = new URLSearchParams(window.location.search).get('tier');
    if (tierParam) {
      activeTiers = tierParam.split(',').map(function (t) { return t.trim(); });
      activeTiers.forEach(function (t) {
        var cb = document.querySelector('.tier-chip__input[value="' + t + '"]');
        if (cb) cb.checked = true;
      });
      syncChipStyles();
    }

    // Initial pagination (always run on load to set up 32-per-page view)
    applyFilterAndPaginate();

    // Close drawer on outside click
    document.addEventListener('click', function () { closeDrawer(); });
    if (filterDrawer) {
      filterDrawer.addEventListener('click', function (e) { e.stopPropagation(); });
    }
  })();

  // ── Auto-fit product titles ───────────────────────────────────────────────
  // Shrinks titles that overflow 2 lines so they always fit without truncation.
  // Runs on load and after JS pagination changes pages.
  window._fitTitles = function () {
    document.querySelectorAll('.product-card__title').forEach(function (el) {
      el.style.fontSize = '';
      var fs = parseFloat(window.getComputedStyle(el).fontSize) || 15;
      while (el.scrollHeight > el.clientHeight + 2 && fs > 11) {
        fs -= 0.5;
        el.style.fontSize = fs + 'px';
      }
    });
  };
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(window._fitTitles);
  } else {
    window.addEventListener('load', window._fitTitles);
  }

  // ── Mobile menu tier/sort events ─────────────────────────────────────────
  window.addEventListener('shopMobileTier', function (e) {
    var tier = e.detail.tier;
    var active = e.detail.active;
    var chips = document.querySelectorAll('.tier-chip__input');
    chips.forEach(function (cb) {
      cb.checked = active && cb.value === tier;
    });
    if (document.getElementById('filter-apply')) {
      document.getElementById('filter-apply').click();
    }
  });

  window.addEventListener('shopMobileSort', function (e) {
    var dir = e.detail.sort;
    var btn = document.querySelector('.sort-ranking-btn[data-sort="' + dir + '"]');
    if (btn) btn.click();
  });

  document.addEventListener('click', function (e) {
    var atcBtn = e.target.closest('.product-card__action-btn');
    if (!atcBtn) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = atcBtn.dataset.variantId;
    var hasVariants = atcBtn.dataset.hasVariants === 'true';
    var productUrl = atcBtn.dataset.productUrl;

    if (hasVariants || !variantId) {
      window.location.href = productUrl;
      return;
    }

    atcBtn.textContent = 'Adding…';
    atcBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        atcBtn.textContent = 'Added!';
        setTimeout(function () {
          atcBtn.textContent = 'Add to Cart';
          atcBtn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        atcBtn.disabled = false;
        window.location.href = productUrl;
      });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
